export default {
  noActiveRecipe: 'Die Kammer {chamber} hat kein aktives Rezept.',
  noDataSourceConnected: 'Die Kammer {chamber} ist nicht mit dem ProTherm controller verbunden. Verbindung kann im Anlagenverwaltung herstellt werden.',
  goToNextStep: 'Weiter zu Schritt {step}',
  goToPreviousStep: 'Zurück zu Schritt {step}',
};
